setTimeout(() => {
  function afficherFormulaire() {
    const mode = document.getElementById("mode").value;
    let html = "";

    if (mode === "complet") {
      html += `
        <div class="input-group">
          <label>Consommation journalière (kWh) :</label>
          <input type="number" id="consoComplet" value="10">
        </div>
        <div class="input-group">
          <label>Autonomie souhaitée (en jours) :</label>
          <input type="number" id="autonomieComplet" value="2">
        </div>
        <div class="input-group">
          <label>Surface de toiture disponible (en m²) :</label>
          <input type="number" id="surfaceToit" value="30">
        </div>
        <div class="input-group">
          <label>Région :</label>
          <select id="region">
            <option value="2900">Provence-Alpes-Côte d'Azur</option>
            <option value="2750">Corse</option>
            <option value="2500">Occitanie</option>
            <option value="2100">Nouvelle-Aquitaine</option>
            <option value="1900">Auvergne-Rhône-Alpes</option>
            <option value="1850">Centre-Val de Loire</option>
            <option value="1800">Bourgogne-Franche-Comté</option>
            <option value="1750">Pays de la Loire</option>
            <option value="1700">Île-de-France</option>
            <option value="1700">Grand Est</option>
            <option value="1600">Bretagne</option>
            <option value="1600">Normandie</option>
            <option value="1500">Hauts-de-France</option>
          </select>
        </div>
        <button class="button" onclick="calculerComplet()">Calculer</button>
      `;
    } else if (mode === "existante") {
      html += `
        <div class="input-group">
          <label>Consommation journalière (kWh) :</label>
          <input type="number" id="consoExistante" value="10">
        </div>
        <div class="input-group">
          <label>Puissance totale de vos panneaux (kWc) :</label>
          <input type="number" id="puissancePanneaux" value="6">
        </div>
        <div class="input-group">
          <label>Autonomie souhaitée (en jours) :</label>
          <input type="number" id="autonomieExistante" value="2">
        </div>
        <button class="button" onclick="calculerExistante()">Calculer</button>
      `;
    } else if (mode === "backup") {
      html += `
        <div class="input-group">
          <label>Consommation estimée des appareils à alimenter (kWh) :</label>
          <input type="number" id="consoBackup" value="5">
        </div>
        <div class="input-group">
          <label>Durée de secours souhaitée (en heures) :</label>
          <input type="number" id="dureeBackup" value="24">
        </div>
        <button class="button" onclick="calculerBackup()">Calculer</button>
      `;
    }

    document.getElementById("formulaire-simulation").innerHTML = html;
    document.getElementById("resultat").innerHTML = "";
    document.getElementById("email-section").style.display = "none";
    document.getElementById("rappel-section").style.display = "none";
  }

  window.afficherFormulaire = afficherFormulaire;

  function getBatterieRecommandee(besoinTotal) {
    const batteries = [
      { capacite: 5, lien: "https://www.dawnicefrance.com/products/batterie-basse-tension-5kwh" },
      { capacite: 10, lien: "https://www.dawnicefrance.com/products/batterie-basse-tension-10kwh" },
      { capacite: 16, lien: "https://www.dawnicefrance.com/products/batterie-basse-tension-15kwh" },
      { capacite: 21, lien: "https://www.dawnicefrance.com/products/batterie-haute-tension-20kwh" }
    ];

    let meilleure = null;
    let minNombre = Infinity;

    batteries.forEach(bat => {
      const nb = Math.ceil(besoinTotal / bat.capacite);
      if (nb < minNombre || (nb === minNombre && bat.capacite > (meilleure?.capacite || 0))) {
        meilleure = { ...bat, nb };
        minNombre = nb;
      }
    });

    return meilleure;
  }

  function calculerComplet() {
    const conso = parseFloat(document.getElementById("consoComplet").value);
    const autonomie = parseFloat(document.getElementById("autonomieComplet").value);
    const surfaceToit = parseFloat(document.getElementById("surfaceToit").value);
    const region = parseFloat(document.getElementById("region").value);

    const surfaceParPanneau = 2.7;
    const pr = 0.75;
    const nbPanneauxMax = Math.floor(surfaceToit / surfaceParPanneau);
    const prodParPanneauJour = (region / 1000) * 630 / 365 * pr;
    const prodTotaleJour = nbPanneauxMax * prodParPanneauJour;
    const besoinTotal = conso * autonomie;
    const meilleure = getBatterieRecommandee(besoinTotal);

    let msg = `
      <p>📐 Surface disponible : <strong>${surfaceToit} m²</strong> → maximum <strong>${nbPanneauxMax}</strong> panneaux Jinko 630W</p>
      <p>☀️ Production solaire estimée : <strong>${prodTotaleJour.toFixed(1)} kWh/jour</strong></p>
      <p>🔋 Besoin de stockage pour ${autonomie} jour(s) : <strong>${besoinTotal.toFixed(1)} kWh</strong></p>
    `;

    if (meilleure) {
      msg += `
        <p>✅ Batterie recommandée : <strong>${meilleure.nb}x ${meilleure.capacite}kWh</strong></p>
        <a href="${meilleure.lien}" target="_blank" class="button">Voir la batterie</a>
      `;
    }

    document.getElementById("resultat").innerHTML = msg;
    document.getElementById("email-section").style.display = "block";
    document.getElementById("rappel-section").style.display = "block";
  }

  function calculerExistante() {
    const conso = parseFloat(document.getElementById("consoExistante").value);
    const autonomie = parseFloat(document.getElementById("autonomieExistante").value);
    const besoinTotal = conso * autonomie;
    const meilleure = getBatterieRecommandee(besoinTotal);

    let msg = `
      <p>🔋 Besoin de stockage pour ${autonomie} jour(s) : <strong>${besoinTotal.toFixed(1)} kWh</strong></p>
    `;

    if (meilleure) {
      msg += `
        <p>✅ Batterie recommandée : <strong>${meilleure.nb}x ${meilleure.capacite}kWh</strong></p>
        <a href="${meilleure.lien}" target="_blank" class="button">Voir la batterie</a>
      `;
    }

    document.getElementById("resultat").innerHTML = msg;
    document.getElementById("email-section").style.display = "block";
    document.getElementById("rappel-section").style.display = "block";
  }

  function calculerBackup() {
    const conso = parseFloat(document.getElementById("consoBackup").value);
    const duree = parseFloat(document.getElementById("dureeBackup").value);
    const besoinTotal = conso * (duree / 24);
    const meilleure = getBatterieRecommandee(besoinTotal);

    let msg = `
      <p>⚡ Stockage nécessaire pour ${duree}h de secours : <strong>${besoinTotal.toFixed(1)} kWh</strong></p>
    `;

    if (meilleure) {
      msg += `
        <p>✅ Batterie recommandée : <strong>${meilleure.nb}x ${meilleure.capacite}kWh</strong></p>
        <a href="${meilleure.lien}" target="_blank" class="button">Voir la batterie</a>
      `;
    }

    document.getElementById("resultat").innerHTML = msg;
    document.getElementById("email-section").style.display = "block";
    document.getElementById("rappel-section").style.display = "block";
  }

  window.calculerComplet = calculerComplet;
  window.calculerExistante = calculerExistante;
  window.calculerBackup = calculerBackup;

  window.afficherFormEmail = () => {
    document.getElementById("form-email").style.display = "block";
  };

  window.afficherFormRappel = () => {
    document.getElementById("form-rappel").style.display = "block";
  };

 window.envoyerParEmail = () => {
  const prenom = document.getElementById("prenomEmail").value;
  const email = document.getElementById("emailEmail").value;
  let resultatHTML = document.getElementById("resultat").innerText;

  // Nettoyage des caractères spéciaux
  resultatHTML = resultatHTML.replace(/[\n\r\t]+/g, " ").trim();

  const payload = {
    prenom,
    email,
    resultat: resultatHTML,
    demande: "Recevoir le résultat par email",
    date: new Date().toLocaleString(),
    type: "prospect"  // Ajouter ce paramètre pour spécifier que c'est un prospect
  };

  fetch("https://hook.eu2.make.com/9dx4wr9brif7ffqalffbh387astb7ydc", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
  .then(res => {
    document.getElementById("messageEmail").innerText = res.ok ?
      "✅ Merci ! Votre résultat vous a été envoyé." :
      "❌ Une erreur est survenue. Veuillez réessayer.";
  })
  .catch(() => {
    document.getElementById("messageEmail").innerText = "❌ Une erreur est survenue. Veuillez réessayer.";
  });
};


  window.envoyerRappel = () => {
    const prenom = document.getElementById("prenomRappel").value;
    const email = document.getElementById("emailRappel").value;
    const telephone = document.getElementById("telephoneRappel").value;
    let resultatHTML = document.getElementById("resultat").innerText;

    // Nettoyage des caractères spéciaux
    resultatHTML = resultatHTML.replace(/[\n\r\t]+/g, " ").trim();

    if (!prenom || !telephone) {
      document.getElementById("messageRappel").innerText = "❌ Merci de renseigner au moins votre prénom et téléphone.";
      return;
    }

    const payload = {
      prenom,
      email,
      telephone,
      resultat: resultatHTML,
      demande: "Souhaite être rappelé",
      date: new Date().toLocaleString(),
      type: "prospect"  // Ajouter ce paramètre pour spécifier que c'est un prospect
    };

    fetch("https://hook.eu2.make.com/9dx4wr9brif7ffqalffbh387astb7ydc", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
    .then(res => {
      document.getElementById("messageRappel").innerText = res.ok ?
        "✅ Merci ! Nous vous contacterons rapidement." :
        "❌ Une erreur est survenue. Veuillez réessayer.";
    })
    .catch(() => {
      document.getElementById("messageRappel").innerText = "❌ Une erreur est survenue. Veuillez réessayer.";
    });
  };

}, 100);
